import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { useContactList } from "../../../store/api/useContactList";
import { RxCross2 } from "react-icons/rx";
import {
  addOrRemoveUserId,
  addUserId,
} from "../../../store/Slices/CreateGroupSlice";
import TextTranslate from "../../../utils/TextTranslate";

export default function SelectedContact() {
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const userData = useAppSelector((state) => state.userData);
  const ChatListArray = useAppSelector((state) => state.chatList);
  const archiveList = useAppSelector((state) => state.archiveList);
  const { data: contactListUser } = useContactList();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userData.user_id == 0) {
      return;
    }
    dispatch(
      addUserId({
        user_id: userData.user_id,
      }),
    );
  }, [userData.user_id, dispatch]);

  const selectedPeople = useMemo(() => {
    return CreateGroup.user_id
      .filter((id) => id != userData.user_id)
      .map((userId) => {
        const contact = contactListUser?.data?.find((c) => c.user_id == userId);
        if (contact) {
          return {
            user_id: userId,
            name: contact.name,
            profile_pic: contact.profile_pic,
          };
        }

        const chats = [
          ...(ChatListArray.Chats ?? []),
          ...(archiveList.Chats ?? []),
        ];
        const peer = chats.find(
          (chat) =>
            chat.Records[0]?.chat_type === "private" &&
            chat.PeerUserData?.user_id == userId,
        )?.PeerUserData;

        return {
          user_id: userId,
          name: peer?.full_name || peer?.user_name || `#${userId}`,
          profile_pic: peer?.profile_pic || "",
        };
      });
  }, [
    CreateGroup.user_id,
    userData.user_id,
    contactListUser?.data,
    ChatListArray.Chats,
    archiveList.Chats,
  ]);

  if (CreateGroup.user_id.length === 0) return null;

  return (
    <div className="shrink-0 border-b border-black/[0.06] px-3 py-3 dark:border-white/[0.08]">
      <div className="flex items-start gap-3 overflow-x-auto">
        <div className="flex w-[4.25rem] shrink-0 flex-col items-center gap-1.5">
          <img
            className="h-12 w-12 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10"
            src={userData.profile_pic}
            alt=""
          />
          <div className="w-full truncate text-center text-[11px] text-lightText">
            <TextTranslate text="You" />
          </div>
        </div>

        {selectedPeople.map((person) => (
          <div
            key={person.user_id}
            className="flex w-[4.25rem] shrink-0 flex-col items-center gap-1.5"
          >
            <div className="relative">
              <img
                className="h-12 w-12 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10"
                src={person.profile_pic}
                alt=""
              />
              <button
                type="button"
                aria-label="Remove"
                onClick={() => {
                  dispatch(
                    addOrRemoveUserId({
                      user_id: person.user_id,
                    }),
                  );
                }}
                className="absolute -right-1 -top-1 grid h-5 w-5 place-content-center rounded-full bg-themeColor text-themeTextColor shadow-sm"
              >
                <RxCross2 className="text-xs" />
              </button>
            </div>
            <div className="w-full truncate text-center text-[11px] text-darkText">
              {person.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
